import { render, staticRenderFns } from "./SubmitCategory.vue?vue&type=template&id=21ff3661&scoped=true"
import script from "./SubmitCategory.vue?vue&type=script&lang=js"
export * from "./SubmitCategory.vue?vue&type=script&lang=js"
import style0 from "./SubmitCategory.vue?vue&type=style&index=0&id=21ff3661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff3661",
  null
  
)

export default component.exports